import { LogManager } from "./log.manager";
import { map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./log.proxy";
import * as i2 from "../app-config/app-configuration.service";
/**
 ****************************************************************
 * Service class for getting logger configuration from server.
 *
 * Written by: Stanislav Korobov
 ****************************************************************
 */
var LogService = /** @class */ (function () {
    function LogService(logProxy, configService) {
        this.logProxy = logProxy;
        this.configService = configService;
    }
    LogService.prototype.getUserData = function () {
        var _this = this;
        return this.logProxy.getLogConfig().pipe(map(function (res) {
            LogManager.parseLoadedConfig(res, _this.configService.Config.WebApiUrl);
            return res;
        }));
    };
    LogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LogService_Factory() { return new LogService(i0.ɵɵinject(i1.LogProxy), i0.ɵɵinject(i2.AppConfigurationService)); }, token: LogService, providedIn: "root" });
    return LogService;
}());
export { LogService };
